module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_112_10.869fb001.pdf";